import React, { Component } from 'react';
import { connect } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import { stampNode } from '../../actions';
import locale from '../../common/locale'
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export class StampButtons extends Component {

  constructor(props) {
    super(props);
    this.state = { useful: false, funny: false, cool: false, money: false }
  }

  clickUseful = () => {
    this.props.stampNode(this.props.id, 'useful', !this.state.useful, this.props.number)
    this.setState({ useful: !this.state.useful });
  }

  clickFunny = () => {
    this.props.stampNode(this.props.id, 'funny', !this.state.funny, this.props.number)
    this.setState({ funny: !this.state.funny });
  }

  clickCool = () => {
    this.props.stampNode(this.props.id, 'cool', !this.state.cool, this.props.number)
    this.setState({cool: !this.state.cool });
  }

  clickMoney = () => {
    this.props.stampNode(this.props.id, 'money', !this.state.money, this.props.number)
    this.setState({money: !this.state.money });
  }

  render() {
    const loc = cookies.get('locale')
    const { server } = this.props

    return(
        <MuiThemeProvider>
          <div className='button useful'
            onClick={this.clickUseful}
            style={{cursor: 'pointer'}}>
            { (this.state.useful)
                ? (<i className="fas fa-child fa-lg active-stamp" />)
                : (<i className="fas fa-child fa-lg" />)
            }
            <span class="stamp-balloon">{locale.useful(loc)}</span>
          </div>
          <div className='button funny'
            onClick={this.clickFunny}
            style={{cursor: 'pointer'}}>
            { (this.state.funny)
              ?(<i className="fab fa-reddit-alien fa-lg active-stamp" />)
              :(<i className="fab fa-reddit-alien fa-lg" />)
            }
            <span class="stamp-balloon">{locale.funny(loc)}</span>
          </div>
          <div className='button cool'
            onClick={this.clickCool}
            style={{cursor: 'pointer'}}>
            { (this.state.cool)
              ?(<i className="fab fa-napster fa-lg active-stamp" />)
              :(<i className="fab fa-napster fa-lg" />)
            }
            <span class="stamp-balloon">{locale.cool(loc)}</span>
          </div>
          <div className='button money'
            onClick={this.clickMoney}
            style={{cursor: 'pointer'}}>
            { (this.state.money)
              ?(<i className="far fa-money-bill-alt fa-lg active-stamp" />)
              :(<i className="far fa-money-bill-alt fa-lg" />)
            }
            <span class="stamp-balloon">{locale.money(loc)}</span>
          </div>
        </MuiThemeProvider>
    )

  }
}


const mapStateToProps = state => ({
});

const mapDispatchToProps = {
  stampNode
}

export default connect(mapStateToProps, mapDispatchToProps)(StampButtons);



// WEBPACK FOOTER //
// ./src/components/nodes/StampButtons.js